(() => {
  const parseEndDate = (value) => {
    if (!value) return null;
    const trimmed = value.trim();

    const dotted = trimmed.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:\s+(\d{1,2}):(\d{2}))?$/);
    if (dotted) {
      const day = Number(dotted[1]);
      const month = Number(dotted[2]);
      const year = Number(dotted[3]);
      const hour = dotted[4] ? Number(dotted[4]) : 23;
      const minute = dotted[5] ? Number(dotted[5]) : 59;
      const date = new Date(year, month - 1, day, hour, minute, 0);
      return Number.isNaN(date.getTime()) ? null : date;
    }

    const dashed = trimmed.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (dashed) {
      const year = Number(dashed[1]);
      const month = Number(dashed[2]);
      const day = Number(dashed[3]);
      const hour = dashed[4] ? Number(dashed[4]) : 23;
      const minute = dashed[5] ? Number(dashed[5]) : 59;
      const date = new Date(year, month - 1, day, hour, minute, 0);
      return Number.isNaN(date.getTime()) ? null : date;
    }

    const normalized = trimmed.replace(' ', 'T');
    const date = new Date(normalized);
    return Number.isNaN(date.getTime()) ? null : date;
  };

  const formatDeadline = (date, locale, showTime) => {
    const datePart = date.toLocaleDateString(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });

    if (!showTime) return datePart;

    const timePart = date.toLocaleTimeString(locale, {
      hour: '2-digit',
      minute: '2-digit',
    });

    return `${datePart} ${timePart}`;
  };

  const formatRelative = (days, hours, minutes, labels, showMinutes) => {
    if (days > 0) {
      if (showMinutes) {
        return `${days} ${labels.days} ${hours}${labels.hours} ${minutes}${labels.minutes}`;
      }
      return `${days} ${labels.days} ${hours}${labels.hours}`;
    }
    if (hours > 0) {
      return `${hours}${labels.hours} ${minutes}${labels.minutes}`;
    }
    return `${minutes}${labels.minutes}`;
  };

  const setupTimer = (node) => {
    const endDateValue = node.dataset.endDate;
    const endDate = parseEndDate(endDateValue);
    if (!endDate) return;

    const prefix = node.dataset.prefix || '';
    const suffix = node.dataset.suffix || '';
    const locale = node.dataset.locale || 'fi-FI';
    const showDeadline = node.dataset.showDeadline === 'true';
    const showDeadlineTime = node.dataset.showDeadlineTime === 'true';
    const showMinutes = node.dataset.showMinutes === 'true';
    const deadlinePrefix = node.dataset.deadlinePrefix || '';
    const endedLabel = node.dataset.endedLabel || '';
    const labels = {
      days: node.dataset.daysLabel || 'päivää',
      hours: node.dataset.hoursLabel || 'h',
      minutes: node.dataset.minutesLabel || 'min',
    };

    const relativeEl = node.querySelector('[data-timer-relative]');
    const deadlineEl = node.querySelector('[data-timer-deadline]');

    const tick = () => {
      const now = new Date();
      const total = endDate.getTime() - now.getTime();

      if (total <= 0) {
        if (relativeEl) relativeEl.textContent = endedLabel;
        if (deadlineEl && showDeadline) {
          deadlineEl.textContent = `${deadlinePrefix} ${formatDeadline(endDate, locale, showDeadlineTime)}`.trim();
        }
        clearInterval(node._timerInterval);
        return;
      }

      const seconds = Math.floor((total / 1000) % 60);
      const minutes = Math.floor((total / 1000 / 60) % 60);
      const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
      const days = Math.floor(total / (1000 * 60 * 60 * 24));

      const relativeValue = formatRelative(days, hours, minutes, labels, showMinutes);
      if (relativeEl) {
        const value = [prefix, relativeValue, suffix].filter(Boolean).join(' ');
        relativeEl.textContent = value.trim();
      }

      if (deadlineEl && showDeadline) {
        deadlineEl.textContent = `${deadlinePrefix} ${formatDeadline(endDate, locale, showDeadlineTime)}`.trim();
      }
    };

    tick();
    node._timerInterval = setInterval(tick, 1000);
  };

  document.querySelectorAll('.timer-content-module__timer').forEach(setupTimer);
})();
